export default "__VITE_ASSET__CoIX4DVi__"